import * as HttpService from "../../../../service/HttpService";

// mock地址域名
export const MOCK_DOMAIN = " http://mock.wxseller.club/mock/5e4a352a2b27d4001662eb23/loadRegulation";

/**
 * 获取负荷调控列表
 * @param params 查询参数
 */
export const getLoadRegulationList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRegulation/recordList", params);
}
/**
 * 获取负荷对象树
 * @param parentId 父节点id
 * @param objType 对象类型
 */
export const getLoadObjTree = (parentId, objType) => {
    return HttpService.get(MOCK_DOMAIN + "/loadRegulation/objTree?parentId=" + parentId + "&objType=" + objType);
}

/**
 * 负荷对象树关键词搜索
 * @param keyword 关键词
 */
export const getLoadObjTreeListBySearch = (keyword, objType) => {
    return HttpService.get(MOCK_DOMAIN + "/loadRegulation/objTree/search?keyword=" + keyword + "&objType=" + objType);
}

/**
 * 负荷对象列表查询
 * @param params 查询参数
 */
export const getLoadObjList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRegulation/objList", {...params, pageSize: 10});
}

/**
 * 新增负荷任务
 * @param params 负荷任务参数
 */
export const addNewLoadTask = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRegulation/addLoadRegulation", params);
}

/**
 * 删除负荷任务
 * @param taskId 负荷任务id
 */
export const deleteLoadTask = (taskIds) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRegulation/deleteLoadRegulation", taskIds);
}

/**
 * 编辑负荷任务
 * @param params 修改的负荷任务信息
 */
export const editLoadTask = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRegulation/editLoadRegulation", params);
}

/**
 * 发送sms短信验证码
 * @param phoneNumber 手机号
 */
export const sendSmsVerificationCode = (smsType) => {
    return HttpService.post(HttpService.DOMAIN + "/verification/sms?operationType=" + smsType);
}

/**
 * 可中断负荷控制
 * @param taskId 任务id
 */
export const breakableLoadControl = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRegulation/breakableLoad/control", params);
}

/**
 * 可中断负荷对象搜索
 * @param taskId 任务id
 */
export const getBreakableLoadObjList = (taskId) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRegulation/breakableLoadObj/search?taskId=" + taskId);
}


/**
 * 可调负荷对象搜索
 * @param taskId 任务id
 */
export const getAdjustableLoadObjList = (taskId) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRegulation/adjustableObj/search?taskId=" + taskId);
}

/**
 * 可调负荷控制
 * @param params 控制参数
 */
export const adjustableLoadControl = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRegulation/adjustableLoad/control", params);
}

/**
 *  曲线查看
 * @param taskId 任务id
 */
export const getCurveView = (taskId) => {
    return HttpService.get(HttpService.DOMAIN + "/loadRegulation/curveView?taskId=" + taskId);
}

/**
 * 负荷效果列表查询
 * @param keyword 关键词
 */
export const getLoadEffectList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRegulation/load_search", {...params, pageSize: 10});
}


